import React from 'react';
import PropTypes from 'prop-types';

import Message from 'components/Message';
import { intlMessage } from 'constants/propTypes';
import { bem } from 'helpers/class-name';

import {
  BOTTOM_ROW_CREDIT_FRAMES,
  SCHEDULE_ILLUSTRATION_CLASS_NAME,
  SCHEDULE_ILLUSTRATION_INSTRUCTOR_NAME,
  TOP_ROW_CREDIT_FRAMES,
} from './GuaranteedMinimumPanel.constants';
import messages from './GuaranteedMinimumPanel.messages';
import './GuaranteedMinimumScheduleIllustration.scss';

const { block, element } = bem('guaranteed-minimum-schedule-illustration');

const SCHEDULE_ROWS = Object.freeze([
  Object.freeze({
    creditFrames: TOP_ROW_CREDIT_FRAMES,
    timeMessage: messages.scheduleIllustrationRow1Time,
  }),
  Object.freeze({
    creditFrames: BOTTOM_ROW_CREDIT_FRAMES,
    timeMessage: messages.scheduleIllustrationRow2Time,
  }),
]);

const CreditDigitRoller = ({ creditFrames }) => (
  <div className={element('credit-digit')}>
    <div className={element('credit-digit-roller')}>
      {creditFrames.map(({ frame, value }) => (
        <span key={frame} className={element('credit-digit-value')}>
          {value}
        </span>
      ))}
    </div>
  </div>
);

CreditDigitRoller.propTypes = {
  creditFrames: PropTypes.arrayOf(
    PropTypes.shape({
      frame: PropTypes.number.isRequired,
      value: PropTypes.number.isRequired,
    })
  ).isRequired,
};

const ScheduleRow = ({ creditFrames, timeMessage }) => (
  <div className={element('row')}>
    <div className={element('row-details')}>
      <div className={element('row-primary')}>
        <Message as="span" className={element('row-time')} message={timeMessage} />
        <span className={element('row-class')}>{SCHEDULE_ILLUSTRATION_CLASS_NAME}</span>
      </div>
      <div className={element('row-secondary')}>
        <Message as="span" message={messages.scheduleIllustrationDuration} />
        <span>{SCHEDULE_ILLUSTRATION_INSTRUCTOR_NAME}</span>
      </div>
    </div>
    <CreditDigitRoller creditFrames={creditFrames} />
  </div>
);

ScheduleRow.propTypes = {
  creditFrames: CreditDigitRoller.propTypes.creditFrames,
  timeMessage: intlMessage.isRequired,
};

const GuaranteedMinimumScheduleIllustration = () => (
  <div aria-hidden className={block()}>
    <Message as="div" className={element('header')} message={messages.scheduleIllustrationDateHeader} />
    <div className={element('rows')}>
      {SCHEDULE_ROWS.map(row => (
        <ScheduleRow key={row.timeMessage.id} {...row} />
      ))}
    </div>
  </div>
);

export default GuaranteedMinimumScheduleIllustration;
